exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#div_footer[data-v-76de2bfa]{content:\" \";display:block;clear:both;border-top:1px solid #eee;margin-left:auto;margin-right:auto;text-align:center;font-size:12.5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-76de2bfa","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/footer.vue
// module id = 114
// module chunks = 0